import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { inject } from 'mobx-react';
import { merge } from 'lodash';

import FormDialog from 'core/form/components/FormDialog';
import BorderedTabs from 'core/components/BorderedTabs';
import BorderedTab from 'core/components/BorderedTab';

import { fields, options } from 'app/forms/config/notification';
import NotificationPreview from './NotificationPreview';
import NotificationSettings from './NotificationSettings';
import NotificationUsage from './NotificationUsage';

@inject('$notifications', '$auth')
export default class NotificationFormDialog extends Component {
  static propTypes = {
    model: PropTypes.object.isRequired,
    filter: PropTypes.array,
    onClose: PropTypes.func,
    showUsedBy: PropTypes.bool
  };

  static defaultProps = {
    filter: [],
    onClose: () => {},
    showUsedBy: true
  };

  handleRemove = () => {
    const { model } = this.props;
    return model.destroy();
  };

  handleSubmit = (form, values) => {
    const { model, onClose } = this.props;

    // lots of deeply nested properties here and only some are getting updated
    model.set({
      ...values,
      config: merge({}, model.get('config'), values.config)
    });

    // allow previous merge so we don't regress on current functionality, but force email updates as merge doesn't deal with array deletions the way we expect.
    const config = model.get('config');

    if (config?.sendingConfig?.usernames) {
      config.sendingConfig.usernames = values?.config?.sendingConfig?.usernames || [];
    }
    if (config?.sendingConfig?.customHeaders) {
      config.sendingConfig.customHeaders = values?.config?.sendingConfig?.customHeaders || [];
    }

    model.set({ config });

    return model.save().then(() => {
      onClose(model);
    });
  };

  render() {
    const { $auth, onClose, model, filter, showUsedBy, ...otherFormProps } = this.props;

    return (
      <FormDialog
        {...otherFormProps}
        model={model}
        fields={fields}
        options={options}
        title={model.isNew ? 'Add Notification Channel' : 'Edit Notification Channel'}
        entityName="Notification Channel"
        isOpen
        onClose={onClose}
        formComponentProps={{ large: true }}
        formActionsProps={{
          onSubmit: this.handleSubmit,
          onCancel: onClose,
          onRemove: this.handleRemove
        }}
        style={{ width: 800, height: 900 }}
        bodyStyle={{ padding: 0 }}
      >
        <BorderedTabs selectedTabBackgroundColor="dialogBackground">
          <BorderedTab
            id="settings"
            title="Settings"
            panel={<NotificationSettings model={model} filter={filter} role="tabpanel" />}
          />
          {$auth.isAdministrator && (
            <BorderedTab id="preview" title="Preview" panel={<NotificationPreview model={model} role="tabpanel" />} />
          )}
          {showUsedBy && (
            <BorderedTab
              id="whereUsed"
              title="Used By"
              panel={<NotificationUsage model={model} role="tabpanel" />}
              disabled={model.isNew}
            />
          )}
        </BorderedTabs>
      </FormDialog>
    );
  }
}
